import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Navbar.css';

// Sprint 7: reads wishlist count live from localStorage - Rakibul
function WishlistNavButton() {
  const [count, setCount] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('menuFavourites') || '[]').length;
    } catch {
      return 0;
    }
  });

  // re-read count whenever localStorage changes
  // (covers adding from Menu page while Navbar is mounted)
  useEffect(() => {
    function syncCount() {
      try {
        const saved = JSON.parse(localStorage.getItem('menuFavourites') || '[]');
        setCount(saved.length);
      } catch {
        setCount(0);
      }
    }
    window.addEventListener('storage', syncCount);
    // also poll every second to catch same-tab updates
    const interval = setInterval(syncCount, 1000);
    return () => {
      window.removeEventListener('storage', syncCount);
      clearInterval(interval);
    };
  }, []);

  return (
    <Link
      to="/wishlist"
      className="wishlist-icon-link"
      aria-label={`Wishlist with ${count} saved pizzas`}
    >
      ♥ Saved
      {count > 0 && <span className="wishlist-badge">{count}</span>}
    </Link>
  );
}

function Navbar({ darkMode, toggleDark }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { cartCount } = useCart();

  return (
    <nav className={`navbar ${darkMode ? 'dark' : ''}`} aria-label="Main navigation">
      <div className="nav-brand">
        <Link to="/" aria-label="M.T.8848 Pizza home">
          M.T.8848 Pizza
        </Link>
      </div>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <li>
          <NavLink
            to="/"
            end
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => (isActive ? 'active-link' : '')}
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/menu"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => (isActive ? 'active-link' : '')}
          >
            Menu
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/build"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => `${isActive ? 'active-link ' : ''}nav-build`.trim()}
          >
            Build Your Own
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => (isActive ? 'active-link' : '')}
          >
            About
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => (isActive ? 'active-link' : '')}
          >
            Contact
          </NavLink>
        </li>
      </ul>

      <div className="nav-right">
        {/* Sprint 7: Wishlist button - Rakibul */}
        <WishlistNavButton />

        {/* Sprint 5: Cart icon with count badge */}
        <Link to="/checkout" className="cart-icon-link" aria-label={`Cart with ${cartCount} items`}>
          🛒 Cart
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </Link>

        <button
          className="dark-toggle"
          onClick={toggleDark}
          aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {darkMode ? '☀ Light' : '☾ Dark'}
        </button>

        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
